export default {
  namespaced: true,
  state: {
    currentPage: 1,
    pageSize: 15,
    count: 0,
    commentsPage: 1,
    commentsCount: 0
  },
  actions: {
    async listAttachment ({ dispatch, state }, params) {
      var id = params.id
      return dispatch('request', { url: `conventional-tracking-requests/${id}/attachments`, method: 'get' }, { root: true })
        .then(response => {
          return response.data
        })
        .catch(error => { throw error })
    },
    async saveAttachment ({ dispatch, state }, params) {
      let id = params.id
      return dispatch('request', { url: `conventional-tracking-requests/${id}/attachments`, method: 'post', data: params.formData }, { root: true })
        .then(response => {
          return response.data
        })
        .catch(error => { throw error })
    },
    async delete ({ dispatch, state }, params) {
      let id = params
      params = undefined
      return dispatch('request', { url: `attachments/${id}`, method: 'delete' }, { root: true })
        .then(response => {
          return response.data
        })
        .catch(error => { throw error })
    },
    async downloadZip ({ dispatch, state }, params) {
      let id = params.id
      return dispatch('downloadFiles', { url: `conventional-tracking-requests/${id}/download_zip` }, { root: true })
        .then(response => {
          return ''
        })
        .catch(error => { throw error })
    },
    async download ({ dispatch, state }, params) {
      let id = params.id
      return dispatch('downloadFiles', { url: `attachments/${id}/download` }, { root: true })
        .then(response => {
          return ''
        })
        .catch(error => { throw error })
    },
    async loadSrc ({ dispatch, state }, params) {
      return dispatch('request', { method: 'get', url: `api/attachments/${params}/base64` }, { root: true })
        .then(response => {
          return response.data
        })
        .catch(error => { throw error })
    }
  },
  getters: {
    objects (state) { return state.objects }
  }
}



// WEBPACK FOOTER //
// ./src/store/attachment.js